import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import ComplianceStatusGrid from './ComplianceStatusGrid';
import PhoneSummaryWidget from './PhoneSummaryWidget';
// import QuickActionsPanel from './QuickActionsPanel';
import RecentActivityFeed from './RecentActivityFeed';
import ProfileUsageWidget from './ProfileUsageWidget';
import { EmptyState } from '../shared';
import './OverviewTab.css';

/**
 * OverviewTab Component
 * Main overview dashboard with all compliance widgets
 */
const OverviewTab = ({ dashboardData, user }) => {
  const history = useHistory();
  const userId = user?.user_id || user?.id;
  console.log("dashboardData",dashboardData);

  if (!dashboardData) {
    return (
      <EmptyState
        title="Welcome to Business"
        description="Loading your compliance dashboard..."
      />
    );
  }

  const handleCardClick = (tab) => {
    history.push(`/trust-hub?tab=${tab}`);
  };

  const handleViewPhones = () => {
    history.push('/trust-hub?tab=phones');
  };

  // Check if profile is approved
  // Backend returns business_profile with a status field
  const profile = dashboardData?.business_profile || dashboardData?.profile;
  const profileStatus = profile?.status;

  console.log("Dashboard Data:", dashboardData);
  console.log("Profile Object:", profile);
  console.log("Profile Status:", profileStatus);

  const isProfileApproved = profileStatus &&
    ['approved', 'twilio-approved', 'verified'].includes(
      typeof profileStatus === 'string' ? profileStatus.toLowerCase() : profileStatus
    );

  console.log("Is Profile Approved:", isProfileApproved);

  // const handleQuickAction = (actionId) => {
  //   switch (actionId) {
  //     case 'create-profile':
  //       history.push('/trust-hub?tab=profile');
  //       break;
  //     case 'register-brand':
  //       history.push('/trust-hub?tab=sms');
  //       break;
  //     case 'setup-cnam':
  //       history.push('/trust-hub?tab=voice');
  //       break;
  //     case 'assign-phones':
  //       history.push('/trust-hub?tab=phones');
  //       break;
  //     default:
  //       break;
  //   }
  // };

  return (
    <div className="overview-tab">
      <ComplianceStatusGrid
        dashboardData={dashboardData}
        onCardClick={handleCardClick}
      />

      <div className="overview-tab__widgets">
        <div className="overview-tab__left">
          {(isProfileApproved ||
            (profile &&
             (profile.status === 'approved' ||
              profile.status === 'twilio-approved' ||
              profile.status === 'verified' ||
              profile.status === 'Approved' ||
              profile.status === 'APPROVED'))) && (
            <>
              <PhoneSummaryWidget
                phoneInventory={dashboardData?.phone_inventory}
                onViewPhones={handleViewPhones}
              />
              {/* {userId && <ProfileUsageWidget userId={userId} />} */}
            </>
          )}
          {/* Quick Actions Panel - Hidden */}
          {/* <QuickActionsPanel onAction={handleQuickAction} /> */}
        </div>

        <div className="overview-tab__right">
          <RecentActivityFeed activities={dashboardData.recent_activity} />
        </div>
      </div>
    </div>
  );
};

OverviewTab.propTypes = {
  dashboardData: PropTypes.object,
  user: PropTypes.object,
};

export default OverviewTab;
